export default [
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    route: 'dashboard-coparate',
    tagVariant: 'light-warning',
    resource: 'Dash',
    action: 'read',
   
  },
]
